import React from "react";
import "@frameworks/web/stylesheets/components/generic/edbuttoncomponent/edButton.scss";
import { Link } from "react-router-dom";
import Edelicon from "../Edelicon";
var EdButton = function (props) {
    var _a;
    // Checks if button or action
    var btnOrActionClass = props.btnTyp === "white-one" ||
        props.btnTyp === "tomato-red" ||
        props.btnTyp === "tomato" ||
        props.btnTyp === "light-navy" ||
        props.btnTyp === "dusty-orange" ||
        props.btnTyp === "white-twenty" ||
        props.btnTyp === "kelly-green-two" ||
        props.btnTyp === "blue-one" ||
        props.btnTyp === "grey-one" ||
        props.btnTyp === "green-btn" ||
        props.btnTyp === "red-btn" ||
        props.btnTyp === "midnight-blue" ||
        props.btnTyp === "midnight-blue-border" ||
        props.btnTyp === "midnight-blue-underline" ||
        props.btnTyp === "grey-suit" ||
        props.btnTyp === "midnight-blue-no-underline" ||
        props.btnTyp === "monochrome-light-grey" ||
        props.btnTyp === "black_one" ||
        props.btnTyp === "blood-red" ||
        props.btnTyp === "blood-red-border" ||
        props.btnTyp === "dark-peach" ||
        props.btnTyp === "dark-peach-rounded" ||
        props.btnTyp === "white-rounded" ||
        props.btnTyp === "dusty-grey-underline" ||
        props.btnTyp === "black-underline" ||
        props.btnTyp === "monochrome-light-grey-border" ||
        props.btnTyp === "white-underline" ||
        props.btnTyp === "han-blue-border" ||
        props.btnTyp === "tomato-rounded" ||
        props.btnTyp === "grey-disabled-rounded" ||
        props.btnTyp === "tomato-filled-rounded"
        ? "button"
        : "";
    return (React.createElement("button", { id: props === null || props === void 0 ? void 0 : props.id, type: props.type, className: "ed_button ".concat(props.btnTyp, " ").concat((_a = props.hoverType) !== null && _a !== void 0 ? _a : "", " ").concat(btnOrActionClass).concat(props.slim ? " slim" : "").concat(props.disabled ? " disabled" : "").concat(props.className ? " ".concat(props.className) : ""), value: props.returnValue, onClick: props.onClick, disabled: props.disabled }, props.value));
};
export var EdButtonIcon = function (props) {
    var _a;
    // Checks if button or action
    var btnOrActionClass = props.btnTyp === "tomato-red" ||
        props.btnTyp === "tomato" ||
        props.btnTyp === "light-navy" ||
        props.btnTyp === "dusty-orange" ||
        props.btnTyp === "white-twenty" ||
        props.btnTyp === "kelly-green-two" ||
        props.btnTyp === "blue-one" ||
        props.btnTyp === "grey-one"
        ? "button"
        : "";
    return (React.createElement("button", { id: props === null || props === void 0 ? void 0 : props.id, type: props.type, className: "ed_button ".concat(props.btnTyp, " ").concat((_a = props.hoverType) !== null && _a !== void 0 ? _a : "", " ").concat(btnOrActionClass).concat(props.slim ? " slim" : "").concat(props.disabled ? " disabled" : "").concat(props.className ? " ".concat(props.className) : ""), onClick: props.onClick, disabled: props.disabled },
        !props.paths && props.btnIcon ? (React.createElement("i", { className: props.btnIcon })) : (props.value),
        " ",
        props.paths && (React.createElement(Edelicon, { className: props.btnIcon, paths: props.paths }))));
};
export var EdLinkButton = function (props) {
    var _a;
    // Checks if button or action
    var btnOrActionClass = props.btnTyp === "tomato-red" ||
        props.btnTyp === "light-navy" ||
        props.btnTyp === "dusty-orange" ||
        props.btnTyp === "white-twenty" ||
        props.btnTyp === "kelly-green-two" ||
        props.btnTyp === "blue-one" ||
        props.btnTyp === "tomato" ||
        props.btnTyp === "grey-one"
        ? "button"
        : "";
    return (React.createElement(Link, { to: props.LinkHref, id: props === null || props === void 0 ? void 0 : props.id, type: props.type, className: "ed_button common_button ib  ".concat(props.btnTyp, " ").concat((_a = props.hoverType) !== null && _a !== void 0 ? _a : "", " ").concat(btnOrActionClass).concat(props.slim ? " slim" : "").concat(props.disabled ? " disabled" : "").concat(props.className ? " ".concat(props.className) : "") }, props.value));
};
export var EdALinkButton = function (props) {
    var _a;
    // Checks if button or action
    var btnOrActionClass = props.btnTyp === "tomato-red" ||
        props.btnTyp === "light-navy" ||
        props.btnTyp === "dusty-orange" ||
        props.btnTyp === "white-twenty" ||
        props.btnTyp === "kelly-green-two" ||
        props.btnTyp === "blue-one" ||
        props.btnTyp === "grey-one" ||
        props.btnTyp === "tomato-rounded"
        ? "button"
        : "";
    return (React.createElement("a", { id: props === null || props === void 0 ? void 0 : props.id, target: props.target ? props.target : "_blank", rel: "noopener noreferrer", href: props.LinkHref, type: props.type, className: "ed_button ib ".concat(props.btnTyp, " ").concat((_a = props.hoverType) !== null && _a !== void 0 ? _a : "", " ").concat(btnOrActionClass).concat(props.slim ? " slim" : "").concat(props.disabled ? " disabled" : "").concat(props.className ? " ".concat(props.className) : "", " text-nowrap") }, props.value));
};
export default EdButton;
